import React from "react";
import PropTypes from "prop-types";

import {
	categoriasDeProducto,
	etiquetaCategoria,
	rutaCategoria,
} from "../../utils/categorias";

/**
 * Chips con todas las categorías de un producto. Se muestra el nombre corto para
 * no alargar la fila y la ruta completa queda en el tooltip. La primera es la
 * principal (`producto.grupo`) y se resalta.
 */
const CategoriasChips = ({ producto, vacio = null }) => {
	const categorias = categoriasDeProducto(producto);

	if (!categorias.length) return vacio;

	return (
		<div style={{lineHeight: 1.1}}>
			{categorias.map((categoria, index) => (
				<div key={categoria.id}>
                    <small
                        className={`m-r-5`}
                        style={{ fontWeight: "normal" }}
                        title={`${rutaCategoria(categoria)}${
                            index === 0 ? " (principal)" : ""
                        }`}
                    >
                        {etiquetaCategoria(categoria)}
                    </small>
                </div>
			))}
		</div>
	);
};

CategoriasChips.propTypes = {
	producto: PropTypes.object,
	vacio: PropTypes.node,
};

export default CategoriasChips;
